/**
 * @flow
 * @relayHash 49f3b1c595f183de664e1413331d278a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type loadHyEventsRequestsQueryVariables = {|
  orgId: string,
  type: string,
|};
export type loadHyEventsRequestsQueryResponse = {|
  +approvalRequests: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +propertyId: string,
        +approved: boolean,
        +propertyName: string,
        +hyevent: ?{|
          +id: string,
          +title: string,
          +publishAt: ?any,
          +status: string,
        |},
        +createdAt: any,
      |}
    |}>
  |}
|};
export type loadHyEventsRequestsQuery = {|
  variables: loadHyEventsRequestsQueryVariables,
  response: loadHyEventsRequestsQueryResponse,
|};
*/


/*
query loadHyEventsRequestsQuery(
  $orgId: ID!
  $type: String!
) {
  approvalRequests(orgId: $orgId, type: $type) {
    edges {
      node {
        id
        propertyId
        approved
        propertyName
        hyevent {
          id
          title
          publishAt
          status
        }
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "approvalRequests",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "ApprovalRequestConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ApprovalRequestEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ApprovalRequest",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "propertyId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "approved",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "propertyName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "hyevent",
                "storageKey": null,
                "args": null,
                "concreteType": "Hyevent",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "publishAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "loadHyEventsRequestsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "loadHyEventsRequestsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "loadHyEventsRequestsQuery",
    "id": null,
    "text": "query loadHyEventsRequestsQuery(\n  $orgId: ID!\n  $type: String!\n) {\n  approvalRequests(orgId: $orgId, type: $type) {\n    edges {\n      node {\n        id\n        propertyId\n        approved\n        propertyName\n        hyevent {\n          id\n          title\n          publishAt\n          status\n        }\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '96d8d9ee909b09c7fcfdfdfa58cf26c2';
module.exports = node;
